import { useEffect, useCallback } from 'react';

const ScrollToTop = () => {
  const scrollToTop = useCallback(() => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > 0) {
      window.scrollTo(0, 0);
    }
  }, []);

  useEffect(() => {
    // Attempt to scroll immediately
    scrollToTop();

    // Set a timeout to try again after a short delay
    const timeoutId = setTimeout(scrollToTop, 30);

    // Also attach to the 'load' event of the window
    window.addEventListener('load', scrollToTop);

    // Cleanup
    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener('load', scrollToTop);
    };
  }, [scrollToTop]);

  return null;
};

export default ScrollToTop;